import { ThemeProps } from '@emotion/react';
import styled from '@emotion/styled';

const HamburgerWrapper = styled('div')`
  width: 24px;
  height: 24px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
`;
const HamburgerLine = styled('span')`
  display: block;
  position: absolute;
  height: 1.5px;
  width: 100%;
  background: ${({ color, theme }: ThemeProps & HamburgerIconProps): string => color || theme.fonts.s5.color};);
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
`;

const HamburgerLine1 = styled(HamburgerLine)`
  top: 4px;
  ${({ isOpen }: HamburgerIconProps): string =>
    isOpen
      ? `
      top: 12px;
      width: 0%;
      height: 0px;
      left: 50%;
    `
      : ''};
`;
const HamburgerLine2LeftHalf = styled(HamburgerLine)`
  top: 12px;
  ${({ isOpen }: HamburgerIconProps): string =>
    isOpen
      ? `
      transform: rotate(45deg);
      height: 1px;
    `
      : ''};
`;
const HamburgerLine2RightHalf = styled(HamburgerLine)`
  top: 12px;

  ${({ isOpen }: HamburgerIconProps): string =>
    isOpen
      ? `
      transform: rotate(-45deg);
      height: 1px;
    `
      : ''};
`;
const HamburgerLine3 = styled(HamburgerLine)`
  top: 20px;

  ${({ isOpen }: HamburgerIconProps): string =>
    isOpen
      ? `
      top: 12px;
      width: 0%;
      height: 0px;
      left: 50%;
    `
      : ''};
`;

interface HamburgerIconProps {
  isOpen: boolean;
  color?: string | undefined;
}

const HamburgerIcon = ({ isOpen, color }: HamburgerIconProps) => {
  return (
    <HamburgerWrapper data-testid="HamburgerIcon">
      <HamburgerLine1 isOpen={isOpen} color={color} />
      <HamburgerLine2LeftHalf isOpen={isOpen} color={color} />
      <HamburgerLine2RightHalf isOpen={isOpen} color={color} />
      <HamburgerLine3 isOpen={isOpen} color={color} />
    </HamburgerWrapper>
  );
};

export default HamburgerIcon;
